<template>
  <div>
    <div class="section">
      <div style="width:80%; min-width:1000px">
        <span class="title">{{ $t('SeaExport.CustomsDeclarationInfo') }}</span>
        <div class="form-row" style="display:flex;flex-direction:row;">
          <div style="display: flex;">
            <div style="flex:1;flex-direction:column;margin-right: 10px;">
              <el-form v-if="!isSalesForSzfs" :disabled="readonly" label-width="90px" label-position="left">
                <el-form-item :label="$t('SeaExport.CustomsBroker')" class="custom">
                  <cargo-advance-select
                    no="1"
                    :select-type="selectTypeNames.basic_data_Company"
                    :data-filter-function="customsBrokerFilter"
                    filterable
                    :default-value="job.customsBroker||''"
                    :method-params="{customsBroker:true,companyLob:'airExport',active:true}"
                    style="width:200px"
                    @parentCallBack="p=>{job.customsBroker=p.value||0}"
                  />
                </el-form-item>
              </el-form>
              <el-form :disabled="readonly" label-width="90px" label-position="left">
                <el-form-item :label="$t('SeaExport.Remarks')" class="custom">
                  <el-input
                    v-model="job.customsRemarks"
                    no="2"
                    type="textarea"
                    :rows="5"
                    style="width:200px"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.customsRemarks,val=>{job.customsRemarks=val})"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div style="flex: 1; margin-left: 10px;">
              <el-form :disabled="readonly" label-width="90px" label-position="left">
                <el-form-item :label="$t('SeaExport.AdvancePayment')">
                  <el-select
                    v-model="advancePaymentValue"
                    no="advancePayment"
                    style="width:200px"
                    @change="handleAdvancePaymentChange"
                  >
                    <el-option
                      v-for="item in SystemConstants.YESORNO_STATES"
                      :key="item.code"
                      :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-form>
              <el-form :disabled="readonly" label-width="90px" label-position="left">
                <el-form-item :label="$t('SeaExport.TaxRemarks')" class="custom">
                  <el-input
                    v-model="job.taxRemarks"
                    no="taxRemarks"
                    type="textarea"
                    :rows="5"
                    style="width:200px"
                    @dblclick.native="showAdvanceTextDialog($t('SeaExport.TaxRemarks'),job.taxRemarks,val=>{job.taxRemarks=val})"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div style="flex: 1; margin-left: 10px;">
              <el-form :disabled="readonly" label-width="90px">
                <el-form-item :label="$t('SeaExport.CustomsDutyAmount')">
                  <auto-number-input
                    v-model="job.customsDutyAmount"
                    no="customsDutyAmount"
                    style="width: 200px"
                    :precision="2"
                    :disabled="readonly"
                    :min="0"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div style="flex: 1; margin-left: 10px;">
              <el-form :disabled="readonly" label-width="90px">
                <el-form-item :label="$t('SeaExport.VatAmount')">
                  <auto-number-input
                    v-model="job.vatAmount"
                    no="vatAmount"
                    style="width: 200px"
                    :precision="2"
                    :disabled="readonly"
                    :min="0"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div style="flex: 1; margin-left: 10px;">
              <el-form :disabled="readonly" label-width="90px">
                <el-form-item :label="$t('SeaExport.PaymentTime')">
                  <el-date-picker
                    v-model="job.paymentTime"
                    no="paymentTime"
                    :disabled="readonly"
                    style="width: 200px"
                    type="date"
                    clearable
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div style="width:80%; min-width:1000px">
        <span class="title">{{ $t('SeaExport.OnwardInfo') }}</span>
        <div class="form-row" style="display:flex;flex-direction:row;">
          <div style="display:flex;flex-direction:column">
            <el-form :disabled="readonly" :label-width="$selectByLang('90px', '110px')" label-position="left">
              <el-form-item :label="$t('SeaExport.TheActualFlight')+'：'" class="custom">
                <el-input v-model="job.actualFlight" no="3" style="width:300px" />
              </el-form-item>
              <el-form-item label="ATD：" class="custom">
                <el-date-picker
                  ref="secondAtd"
                  v-model="job.secondAtd"
                  no="4"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  style="width:300px"
                  @blur="()=> { handleBlur('secondAtd', null, true, false, job) }"
                />
              </el-form-item>
            </el-form>
            <el-form :disabled="readonly" :label-width="$selectByLang('90px', '110px')" label-position="left">
              <el-form-item :label="$t('SeaExport.OnwardInfo')+'：'" class="custom">
                <el-input
                  v-model="job.onwardJourney"
                  no="5"
                  type="textarea"
                  :rows="5"
                  style="width:300px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.OnwardInfo'),job.onwardJourney,val=>{job.onwardJourney=val})"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <el-button no="6" type="primary" :disabled="!btnEnable" @click="addCustInfoHandler">{{ $t('SeaExport.NewCustomsDeclaration') }}</el-button>
          <el-button no="7" type="primary" :disabled="!btnEnable" @click="editCustInfoHandler">{{ $t('SeaExport.EditCustomsDeclaration') }}</el-button>
          <el-button no="8" type="danger" :disabled="!btnEnable" @click="delCustInfoHandler">{{ $t('SeaExport.DeleteCustomsDeclaration') }}</el-button>
          <el-button v-show="closeXhqCustoms && !openOujianCustoms && job.lob === 'AE' && !openMeiHuaCustom" no="GetOcrFile" type="primary" :disabled="job.jobState !== 0 || isEdit || !$checkPermission(['button_customs_IdentifyTheCustoms'])" @click="getOcrFileHandler">{{ $t('CargoMsg.Cargo_IdentifyTheCustomsDeclaration') }}</el-button>
          <el-button v-show="closeXhqCustoms && !openOujianCustoms && job.lob === 'AE' && !openMeiHuaCustom" no="RefreshOcrFile" type="primary" :disabled="job.jobState !== 0 || isEdit" @click="loadList">{{ $t('CargoMsg.Cargo_RefreshCustomsDeclaration') }}</el-button>
        </cargo-button-group-slider>
      </div>
    </div>
    <div style="height: 100%;margin-top: 5px;">
      <cargo-ag-grid
        :config-module="!openMeiHuaCustom ? '1900003' : '1900005'"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="!openMeiHuaCustom ? columnDefs : xhqColumnDefs"
        :row-data="rowData"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 编辑弹框 -->
    <customs-info-dialog ref="customsInfoDialog" :visible.sync="editDialog.visible" :is-sales-for-szfs="isSalesForSzfs" :selected-customs-info="selectedCustomsInfo" :job="job" @successHandler="successHandler" />
    <!-- 编辑弹框 欧坚 -->
    <customs-info-dialog-ouj ref="customsInfoDialogOuj" :visible.sync="editOujianDialog.visible" :selected-customs-info="editOujianDialog.customsInfo" :job="editOujianDialog.job" @successHandler="successHandler" @close="editOujianDialog.visible=false" />
    <!-- 海关回执弹窗 -->
    <customs-info-interact-res-dialog ref="customsInfoInteractResDialog" :visible.sync="interactResDialog.visible" :customs-id="interactResDialog.customsId" />
    <!-- 回执文件弹窗 -->
    <file-history-dialog ref="fileHistoryDialog" :visible.sync="fileHistoryDialog.visible" :customs-id="fileHistoryDialog.customsId" />
    <!--查看海关回执文件-->
    <customs-info-res-file-history-dialog :visible.sync="customsInfoFileDialog.visible" :customs-info="customsInfoFileDialog.customsInfo" :customs-info-key="customsInfoFileDialog.customsInfoKey" />

    <!-- 海关回执记录弹窗 -->
    <customs-receipt-record-dialog ref="customsReceiptRecordDialog" :visible.sync="customsReceiptRecordDialog.visible" :selected-customs-info="customsReceiptRecordDialog.customsInfo" />

    <information-comparison-dialog ref="informationComparisonDialog" :visible.sync="informationComparisonDialog.visible" :data="informationComparisonDialog.data" />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceText"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :warning-count="-1"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!--   iChannel: 3 报关, pageSource: 'customsInfo' 报关页面 -->
    <drop-uploader
      v-if="closeXhqCustoms && !openOujianCustoms && job.lob === 'AE'"
      ref="dropUploader"
      :action="URL.AIdiscern.importAndAnalyseFile"
      :upload-params="{ source: INTELLIGENT_DOCUMENT_SOURCE_10.code, iChannel: 3, jobUuid: job.uuid, pageSource: 'customsInfo', officeId: $store.getters.currentOfficeId }"
      :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','tif', 'msword', 'ms-excel', 'jpeg', 'rtf']"
      :file-format="fileFormat"
      :multiple="false"
      :open-drag="false"
      :bs-open="bsOpen"
      @upload-result="uploadResultHandler"
    />
  </div>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { customsList, customsInfoDeleteAll, customsSave } from '@/api/seaExport/customsInfo'
import { File } from '@/class/model/booking/File'
import CustomsInfoDialog from '@/components/Cargo/Job/customsInfoDialog'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { saveFile, queryFileByOriginFileId } from '@/api/seaExport/file'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import customsInfoResFileHistoryDialog from '@/components/Cargo/FileUpload/customsInfoResFileHistoryDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import customsInfoDialogOuj from '@/components/Cargo/Job/booking/tabs/ouJian/customsInfoDialogOuj'
import customsInfoInteractResDialog from '@/components/Cargo/Job/booking/tabs/ouJian/customsInfoInteractResDialog'
import fileHistoryDialog from '@/components/Cargo/Job/booking/tabs/ouJian/fileHistoryDialog'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { checkBsItemOpened } from '@/api/booking/job'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import URL from '@/api/urlTranslator'
import AnalysisDuration from './AnalysisDuration'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { CustomsInfo } from '@/class/model/booking/CustomsInfo'
import { INTELLIGENT_DOCUMENT_SOURCE_10 } from '@/class/cargo/model/parameters/SystemConstants'
import { queryCustomsAnalysisResultsUrlFunc } from '@/api/seaExport/intelligentBooking'
import { getStateByCode } from '@/class/cargo/model/parameters/CommonState'
import * as XhqCustomState from '@/class/cargo/model/parameters/XhqCustomState'
import { handleBlur } from '@/utils/commonUtil'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import InformationComparisonDialog from '@/components/Cargo/Job/informationComparisonDialog.vue'
import customsReceiptRecordDialog from '@/components/Cargo/Job/booking/tabs/customsReceiptRecordDialog'

export default {
  name: 'TabCustomsInfo',
  components: {
    customsReceiptRecordDialog, InformationComparisonDialog,
    AutoNumberInput, CustomsInfoDialog, DropUploader, cargoAdvanceSelect, cargoCompanySelect, customsInfoResFileHistoryDialog, CargoButtonGroupSlider, customsInfoDialogOuj,
    customsInfoInteractResDialog, fileHistoryDialog, cargoRichTextarea },
  mixins: [SenderAndReceiver],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    isSalesForSzfs: { type: Boolean, default: false }
  },
  data() {
    return {
      handleBlur,
      selectTypeNames: TYPE_NAMES,
      bsOpen: false,
      URL,
      INTELLIGENT_DOCUMENT_SOURCE_10,
      fileFormat: '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.gif,.png,.tif',
      xinHaoQiApi: 0,
      form: {
        uuid: ''
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.onRowClicked,
        onCellClicked: this.showInteractRes
      },
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false
      },
      currentUser: {},
      job: new AirExportJob().fillDefaultValue().getData(),
      selectedCustomsInfo: {},
      isNew: false,
      lockButton: false,
      btnEnable: false,
      editOujianDialog: {
        visible: false,
        job: {},
        customsInfo: {}
      },
      interactResDialog: {
        visible: false,
        customsId: ''
      },
      fileHistoryDialog: {
        visible: false,
        customsId: ''
      },
      customsInfoFileDialog: {
        visible: false,
        customsInfo: null,
        customsInfoKey: null
      },
      customsReceiptRecordDialog: {
        visible: false,
        customsInfo: {}
      },
      informationComparisonDialog: {
        visible: false,
        data: {}
      },
      openMeiHuaCustom: false
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    closeXhqCustoms() { // 关闭信号旗报关参数
      return this.xinHaoQiApi === 0
    },
    openOujianCustoms() {
      return Number(cache.config.get('openOujianCustoms')) === 1
    },
    openOujianAndAe() {
      return this.openOujianCustoms
    },
    advancePaymentValue: {
      get() {
        return this.job.advancePayment ? 1 : 0
      }
    },
    columnDefs() {
      if (!this.openOujianAndAe) {
        const list = [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.BlNo'),
            field: 'mbl',
            colId: 'mbl',
            width: 120,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.CustomsCode'),
            field: 'tenDigitCode',
            colId: 'tenDigitCode',
            width: 200
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            field: 'soNo',
            colId: 'soNo',
            width: 200
          },
          {
            headerName: this.$t('SeaExport.DateOfCustomsDeclaration'),
            field: 'customsDate',
            colId: 'customsDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsReceiptState'),
            field: '',
            colId: 'customsReceiptState',
            width: 120
          },
          {
            headerName: this.$t('SeaExport.CustomsReceiptFile'),
            field: '',
            colId: 'customsReceiptFile',
            width: 120,
            cellRenderer: params => {
              return '<a style="color: #0A0AFF; text-decoration: underline">' + this.$t('FileHistory.view') + '</a>'
            },
            onCellClicked: (params) => {
              if (params.event.target.tagName === 'A') {
                this.showCustomsInfoResFileDialog(params.data)
              }
            }
          },
          {
            headerName: this.$t('SeaExport.UpdateTime'),
            field: 'dateModified',
            colId: 'dateModified',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'),
            field: 'declareCustomsState',
            colId: 'declareCustomsState',
            width: 120,
            cellRenderer: (params) => {
              return this.customsStateLabFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CommodityInspectionOrNot'),
            field: 'commodityInspection',
            colId: 'commodityInspection',
            width: 120,
            cellRenderer: (params) => {
              return this.commodityLabFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsInspectionOrNot'),
            field: 'spotInspection',
            colId: 'spotInspection',
            width: 120,
            cellRenderer: (params) => {
              return this.commodityLabFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsNo'),
            field: 'customsNo',
            colId: 'customsNo',
            width: 120
          },
          {
            headerName: this.$t('SeaExport.Remarks'),
            field: 'remarks',
            colId: 'remarks',
            width: 120
          }
        ]
        if (!this.isSalesForSzfs) {
          list.push({
            headerName: this.$t('SeaExport.OperatingCompany'),
            field: 'companyCname',
            colId: 'companyCname',
            width: 200
          })
        }
        if (this.closeXhqCustoms) {
          list.push({
            headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationNo'),
            field: 'customsDeclarationNo',
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AnalysisStatus'),
            colId: 'analysisStatus',
            field: 'analysisStatus',
            cellRendererFramework: AnalysisDuration,
            filterValueGetter: (params) => {
              const s = getStateByCode(SystemConstants.ANALYSIS_STATUS_LIST, params.value)
              if (s) {
                return this.$store.getters.language === 'zh' ? s.chineseName : s.englishName
              } else {
                return ''
              }
            },
            width: 240
          },
          {
            headerName: this.$t('SeaExport.Quantity2'),
            field: 'quantity',
            width: 120
          },
          {
            headerName: this.$t('SeaExport.ExchangeRate'),
            field: 'rate',
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SystemFee'),
            field: 'systemFee',
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InsurancePremium'),
            field: 'insurancePremium',
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ProcessingFee'),
            field: 'processingFee',
            width: 120
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FOBValue'),
            field: 'freeOnBoard',
            width: 120
          })
        }
        return list
      } else {
        return [
          {
            headerName: '',
            field: '',
            width: 65,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false
          },
          {
            headerName: this.$t('SeaExport.BlNo'),
            field: 'mbl',
            colId: 'mbl',
            width: 120,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.OperatingCompany'),
            field: 'companyCname',
            colId: 'companyCname',
            width: 200
          },
          {
            headerName: this.$t('SeaExport.CustomsCode'),
            field: 'tenDigitCode',
            colId: 'tenDigitCode',
            width: 200
          },
          {
            headerName: this.$t('SeaExport.SoNo'),
            field: 'soNo',
            colId: 'soNo',
            width: 200
          },
          {
            headerName: this.$t('SeaExport.DateOfCustomsDeclaration'),
            field: 'customsDate',
            colId: 'customsDate',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsReceiptState'),
            field: 'interactRes',
            colId: 'interactRes',
            width: 120,
            cellRenderer: (params) => {
              return '<a style="color: #1605FB;text-decoration:underline">' + params.value + '</a>'
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsReceiptFile'),
            field: 'fileHistory',
            colId: 'fileHistory',
            width: 120,
            cellRenderer: (params) => {
              return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('SeaExport.ViewFile') + '</a>'
            }
          },
          {
            headerName: this.$t('SeaExport.UpdateTime'),
            field: 'dateModified',
            colId: 'dateModified',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'),
            field: 'declareCustomsState',
            colId: 'declareCustomsState',
            width: 120,
            cellRenderer: (params) => {
              return this.customsStateLabFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CommodityInspectionOrNot'),
            field: 'commodityInspection',
            colId: 'commodityInspection',
            width: 120,
            cellRenderer: (params) => {
              return this.commodityLabFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsInspectionOrNot'),
            field: 'spotInspection',
            colId: 'spotInspection',
            width: 120,
            cellRenderer: (params) => {
              return this.commodityLabFun(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsNo'),
            field: 'customsNo',
            colId: 'customsNo',
            width: 120
          },
          {
            headerName: this.$t('SeaExport.Remarks'),
            field: 'remarks',
            colId: 'remarks',
            width: 120
          }
        ]
      }
    },
    xhqColumnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomsBroker'),
          field: 'customsBroker',
          width: 120,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_9') : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.CustomsDeclareTime'),
          field: 'declareTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptFile'),
          field: 'fileHistory',
          width: 120,
          cellRenderer: (params) => {
            return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('SeaExport.ViewFile') + '</a>'
          },
          onCellClicked: (params) => {
            queryFileByOriginFileId(params.data.uuid).then(res => {
              this.fileHistoryDialog.visible = true
              this.fileHistoryDialog.customsId = res.data.uuid
            })
          }
        },
        {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'dateModified',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.NoticeBgh'),
          field: 'noticeBgh',
          width: 120,
          cellRenderer: (params) => {
            return params.value ? 'Y' : 'N'
          }
        },
        {
          headerName: this.$t('CargoMsg.InformationComparison'),
          field: 'informationComparison',
          width: 120,
          cellRenderer: (params) => {
            if (!params.data.ifXhqCustomsDataReceived) {
              return ''
            }
            if ((params.data.localQuantity === params.data.customsQuantity) && (params.data.localWeight === params.data.customsWeight)) {
              return this.$t('Message.Agreement')
            }
            return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('CargoMsg.Diff') + '</a>'
          },
          onCellClicked: (params) => {
            if (this.rowData.length > 1) {
              this.$message.warning(this.$t('SeaExport.OnlySupportOneCustomsDeclaration'))
            }
            this.informationComparisonDialog.visible = true
            this.informationComparisonDialog.data = params.data
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomsDeclarationStatus'),
          field: 'xhqCustomState',
          width: 120,
          cellRenderer: (params) => {
            if (params.value === XhqCustomState.NOT_SENT.code || params.value === XhqCustomState.WITHDRAWN.code) {
              return this.$t('CargoMsg.NotSendingCustomerFile')
            } else if (params.value === XhqCustomState.SENT.code) {
              return this.$t('CargoMsg.CustomerFileHasBeenSent')
            } else if (params.value === XhqCustomState.SENT_LCL_TASK.code) {
              return this.$t('CargoMsg.LCLTaskSent')
            }
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsStatus'),
          field: 'customsStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.columnLabelFunc(SystemConstants.CUSTOMS_STATUS, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsBrokerStatus'),
          field: 'customsBrokerStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.columnLabelFunc(SystemConstants.CUSTOMS_BROKER_STATUS, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptRecord'),
          field: 'version',
          width: 150,
          cellRenderer: (params) => {
            return '<a style="color: #1605FB;text-decoration:underline">' + this.$t('SeaExport.View') + '</a>'
          },
          onCellClicked: (params) => {
            // 查看海关回执记录
            this.customsReceiptRecordDialog.visible = true
            this.customsReceiptRecordDialog.customsInfo = params.data
          }
        }
      ]
    }
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }

      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.xinHaoQiApi = Number(cache.config.get('xinHaoQiApi'))
      this.openMeiHuaCustom = Number(cache.config.get('openMeiHuaCustom')) === 1
      this.currentUser = cache.user
      this.job = row
      this.queryBs()
      if (row.uuid) {
        this.display()
        // 加载列表数据
        await this.loadList()
      }
    },
    queryBs() {
      // 查询计费系统是否开通托书
      checkBsItemOpened(SystemConstants.TYPE_CUSTOMS_ANALYSIS).then(res => {
        if (!res.data || res.data === -1) {
          this.bsOpen = false
        } else {
          this.bsOpen = true
        }
      })
    },
    display() {
      this.btnEnable = false
      if (!StrUtils.isEmpty(this.job.uuid)) {
        this.btnEnable = true
      }
    },
    async fillMode() {
      await JobUtils.synCustomsBroker(this.job, this.job.customsBroker, 0)
    },
    // 处理 select 的 change 事件
    handleAdvancePaymentChange(value) {
      this.job.advancePayment = value === 1
    },
    async getSubmitData() {
      await this.fillMode()
      const job = { ...this.job }
      await cache.load(cacheName.CONFIG)
      const syncMode = Number(cache.config.get('CustomsBrokerSynMode'))
      if (syncMode === 1 && this.job.customsBroker > 0) { // JobUtils.synCustomsBroker中修改file，customsInfo
        return {
          job,
          file: job.file,
          customsInfo: job.customsInfo
        }
      } else {
        return {
          job
        }
      }
    },
    async loadList() {
      await this.doLoadList()
      this.refreshCustomsAnalysis(1)
    },
    async doLoadList() {
      await customsList(this.job.uuid).then(res => {
        this.rowData = res.data
      })
      this.selectedCustomsInfo = {}
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
      }
    },
    customsStateLabFun(declareCustomsState) {
      if (declareCustomsState === 1) {
        return this.$t('SeaExport.Recorded')
      } else if (declareCustomsState === 2) {
        return this.$t('SeaExport.ListPulled')
      } else if (declareCustomsState === 3) {
        return this.$t('SeaExport.AtReception')
      } else if (declareCustomsState === 4) {
        return this.$t('SeaExport.CustomsDeclared')
      } else if (declareCustomsState === 5) {
        return this.$t('SeaExport.Undeclared')
      } else if (declareCustomsState === 6) {
        return this.$t('SeaExport.CustomsExamination')
      } else if (declareCustomsState === 7) {
        return this.$t('SeaExport.InspectionExamination')
      } else if (declareCustomsState === 8) {
        return this.$t('SeaExport.ExamedWithoutReleasing')
      } else if (declareCustomsState === 9) {
        return this.$t('SeaExport.AmendDeclaration')
      } else if (declareCustomsState === 10) {
        return this.$t('SeaExport.NotifyToDeclare')
      } else if (declareCustomsState === 11) {
        return this.$t('SeaExport.CustomsHasCheck')
      } else if (declareCustomsState === 12) {
        return this.$t('SeaExport.CustomsExamed')
      } else if (declareCustomsState === 13) {
        return this.$t('SeaExport.CustomsOneRelease')
      } else if (declareCustomsState === 14) {
        return this.$t('SeaExport.CustomsRelease2')
      } else if (declareCustomsState === 15) {
        return this.$t('SeaExport.hasBeanSend')
      } else if (declareCustomsState === 16) {
        return this.$t('SeaExport.notSend')
      } else if (declareCustomsState === 17) {
        const value = this.$t('SeaExport.sendFailed')
        return `<span style="color: red">${value}</span>`
      } else if (declareCustomsState === 18) {
        return this.$t('SeaExport.SelfDeclaration')
      }
      return this.$t('SeaExport.UnknownState')
    },
    commodityLabFun(commodityInspection) {
      const val = Boolean(commodityInspection)
      if (val) {
        return this.$t('Message.Yes')
      }
      return this.$t('Message.No')
    },
    // 新增报关单
    addCustInfoHandler() {
      const customsInfo = {}
      customsInfo.mbl = this.job.mbl
      customsInfo.customsDate = new Date()
      customsInfo.jobUuid = this.job.uuid
      if (this.openOujianAndAe) {
        customsInfo.lob = this.job.lob
        customsInfo.declareCustomsState = 16
        customsInfo.portDistrict = this.job.portDistrict
      }
      this.isNew = true
      this.popUpCustomInfoWindow(customsInfo)
    },
    popUpCustomInfoWindow(customsInfo) {
      if (this.openOujianAndAe) {
        this.editOujianDialog.saveCallBack = this.successHandler
        const customsInfoDialogOuj = this.$refs.customsInfoDialogOuj
        customsInfoDialogOuj.isSe = false
        customsInfoDialogOuj.isSi = false
        customsInfoDialogOuj.isAe = true
        customsInfoDialogOuj.isAi = false
        customsInfoDialogOuj.isRe = false
        customsInfoDialogOuj.isLcl = false
        customsInfoDialogOuj.isNew = this.isNew
        this.editOujianDialog.customsInfo = customsInfo
        this.editOujianDialog.job = this.job
        this.editOujianDialog.visible = true
      } else {
        this.$nextTick(() => {
          this.$refs.customsInfoDialog.onShow(this.isNew ? 'add' : 'edit')
          this.editDialog.visible = true
        })
      }
    },
    onRowClicked(event) {
      this.selectedCustomsInfo = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedCustomsInfo = node.data
          }
        })
      }
    },
    // 编辑报关单
    editCustInfoHandler() {
      var arr = Object.keys(this.selectedCustomsInfo)
      if (arr.length === 0) {
        this.$message.info(this.$t('Message.SelectCustomsInformation'))
        return
      }
      this.selectedCustomsInfo.portDistrict = this.job.portDistrict
      this.isNew = false
      this.popUpCustomInfoWindow(this.selectedCustomsInfo)
    },
    // 新增/编辑成功都走这里
    async successHandler(data) {
      if (this.isNew) {
        await this.addFile(data)
        this.isNew = false
      }
      await this.loadList()
    },
    // 设置 选中行
    setGridSelect(uuid) {
      const nodes = this.gridApi.getRenderedNodes()
      if (uuid) {
        for (const item of nodes) {
          if (uuid === item.data.uuid) {
            item.setSelected(true)
            this.selectedCustomsInfo = item.data
            break
          }
        }
      }
    },
    async addFile(customsInfo) {
      const file = new File().fillDefaultValue().getData()
      file.jobUuid = this.job.uuid
      file.jobNo = this.job.jobNo
      file.fileType = String(FileType.BGD_TYPE.code)
      file.tenDigitCode = customsInfo.tenDigitCode
      file.companyCname = customsInfo.companyCname
      file.customsBroker = customsInfo.customsBroker
      file.fileNo = customsInfo.soNo
      file.customsNo = customsInfo.customsNo
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.customerId)
      file.receiveDate = new Date()
      file.receiveCompany = companyCache ? companyCache.chineseName : ''
      file.receivePerson = this.job.customerContact
      file.receiveTel = this.job.contactTelephone
      file.expressAddress = companyCache ? companyCache.address : ''
      file.state = 0
      file.branchId = this.job.opOffice
      file.inputBy = this.currentUser.userId
      file.inputByDep = this.$store.getters.currentDeptId
      file.inputDate = new Date()
      file.tax = false
      file.originFileId = customsInfo.uuid
      file.currentHolder = this.currentUser.userId
      file.remark = customsInfo.remarks
      await saveFile(file)
    },
    delCustInfoHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.SureDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = Array.from(rows, p => p.uuid)
        customsInfoDeleteAll(uuids).then(res => {
          this.loadList()
        })
      }).catch(() => {
      })
    },
    getOcrFileHandler() {
      if (this.rowData) {
        for (const dd of this.rowData) {
          if (dd.analysisStatus === SystemConstants.ANALYSIS_STATUS_1.code) {
            this.$message.warning(this.$t('CargoMsg.Cargo_IdentifyTheCustomsTips'))
            return
          }
        }
      }
      // 计费系统校验
      checkBsItemOpened(SystemConstants.TYPE_CUSTOMS_ANALYSIS).then(res => {
        this.bsOpen = false
        if (!res.data) {
          // 未开通
          this.$message.warning(this.$t('CargoMsg.Cargo_CustomsActivatedTip'))
          return
        } else if (res.data <= 0) {
          // 余额不足
          this.$message.warning(this.$t('CargoMsg.Cargo_CustomsActivatedTip2'))
          return
        }
        this.bsOpen = true
        this.$refs.dropUploader.triggeFileSelectWindow()
      })
    },
    uploadResultHandler(fileId) {
      if (!fileId) {
        return
      }
      const customsInfo = new CustomsInfo().fillDefaultValue().getData()
      customsInfo.mbl = this.job.mbl
      customsInfo.customsDate = new Date()
      customsInfo.jobUuid = this.job.uuid
      customsInfo.declareCustomsType = ''
      customsInfo.lob = this.job.lob
      if (this.job.lob === 'AE') {
        customsInfo.declareCustomsState = 0
      }
      if (this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code ||
        this.job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code ||
        this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) {
        customsInfo.verificationSheetRequired = false
      } else {
        customsInfo.verificationSheetRequired = true
      }
      customsInfo.xhqCustomState = XhqCustomState.NOT_SENT.code
      customsInfo.soNo = this.job.soNo
      customsInfo.customsFileId = fileId
      customsInfo.analysisStatus = SystemConstants.ANALYSIS_STATUS_1.code
      customsSave(customsInfo).then(res => {
        this.loadList()
      })
    },
    // 这里请求后端获取解析结果
    refreshCustomsAnalysis(i) {
      setTimeout(() => {
        if (i > 10) {
          return
        }
        if (this.rowData && this.rowData.length > 0) {
          const pendingParsing = this.rowData.filter(e => e.analysisStatus === SystemConstants.ANALYSIS_STATUS_1.code)
          if (pendingParsing && pendingParsing.length > 0) {
            this.doLoadList()
            this.refreshCustomsAnalysis(i++)
          }
        }
      }, i === 1 ? 10000 : 5000)
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.airExport && item.active
    },
    // 组装打印参数
    getPrintData() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length <= 0) {
        this.$message.warning(this.$t('Message.SelectDeclarations'))
        return
      }
      const params = {}
      const uids = Array.from(items, p => p.uuid)
      params.CUSTOMS_INFO_UUID = uids.join(',')
      params.customsInfo_UUID_List = uids
      params.jobuuid = this.job.uuid
      params.category = 'CustomsList'
      params.ctx = new AirExportJob(this.job)
      this.$logger.log('params', params)
      return params
    },
    // 回执文件弹窗
    showCustomsInfoResFileDialog(row) {
      if (this.openOujianAndAe) {
        if (row.colDef.field === 'interactRes' && row.data.interactRes) {
          this.interactResDialog.customsId = row.data.uuid
          this.interactResDialog.visible = true
        } else if (row.colDef.field === 'fileHistory') {
          queryFileByOriginFileId(row.data.uuid).then(res => {
            this.fileHistoryDialog.visible = true
            this.fileHistoryDialog.customsId = res.data.uuid
          })
        }
      } else {
        if (row.data) {
          this.customsInfoFileDialog.customsInfo = row.data
          this.customsInfoFileDialog.customsInfoKey = row.data.uuid
          this.customsInfoFileDialog.visible = true
        }
      }
    }
  }
}
</script>

<style>
</style>
